import history from 'app/history';
import { getSelectedOffer } from 'app/modules/corporate/service/corporate.service';
import { updateCustomer } from 'app/modules/customer/service/customer.service';
import { gtmEvent } from 'app/modules/gtm/service/gtm.service';
import { globalError, TYPE_ERROR } from 'app/shared/error/error-global';
import { translate } from 'react-jhipster';
import { subscriptionApi } from '../api';
import { ACTION_TYPES } from './store/subscription-actions';

export const getSubscription = (subscriptionNumber: string) => async dispatch => {
  const result = await subscriptionApi.getSubscription(subscriptionNumber);

  if (result.isFailure) {
    // globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return;
  }

  const subscription = result.getValue();

  await dispatch({
    type: ACTION_TYPES.SET_SUBSCRIPTION,
    payload: {
      subscriptionNumber: subscription.number,
      legalEndDateReflection: new Date(subscription.legalEndDateReflection),
      ...subscription
    }
  });

  await dispatch(updateCustomer({ ...subscription.subscriber, confirmEmail: subscription.subscriber.email }));

  await dispatch(getSelectedOffer(subscription.offers[0]));
};

export const initializeJourney = (shortOfferCode: string) => async (dispatch, getState) => {
  const { isWithoutOffer, steps } = await getState().config;
  if (!isWithoutOffer) {
    let result = null;
    if (!shortOfferCode) result = await subscriptionApi.initializeJourney();
    else {
      dispatch({
        type: ACTION_TYPES.SET_SHORT_OFFER_CODE,
        payload: {
          shortOfferCode
        }
      });
      result = await subscriptionApi.initializeJourneyWithShortCode(shortOfferCode);
    }

    if (result.isFailure) {
      globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
      return;
    }

    const journey = result.getValue();

    await dispatch({
      type: ACTION_TYPES.SET_INITIALIZE_SUBSCRIPTION,
      payload: {
        offers: journey.offers
      }
    });
    if (journey.offers) {
      await dispatch(getSelectedOffer(journey.offers[0]));
    }
  }
};

export const getSecureSubscription = (secureToken: string, subscriptionNumber: string) => async dispatch => {
  const result = await subscriptionApi.getSecureSubscription(secureToken, subscriptionNumber);

  if (result.isFailure) {
    const error = result.errorValue();
    if (error.type === 'ForbiddenException') {
      history.push('/too-late');
    } else {
      globalError.next({ type: TYPE_ERROR.GLOBAL, error });
    }
    return;
  }

  const subscription = result.getValue();

  await dispatch({
    type: 'subscription/SET_SUBSCRIPTION',
    payload: {
      subscriptionNumber: subscription.number,
      offers: subscription.offers,
      signTxnCompletedAt: subscription.signTxnCompletedAt,
      status: subscription.status
    }
  });

  await dispatch(updateCustomer({ ...subscription.subscriber, confirmEmail: subscription.subscriber.email }));

  await dispatch(getSelectedOffer(subscription.offers[0]));

  history.replace('/' + subscriptionNumber);
};

export const createPendingSubscription = (prospection: any, reCaptchaValue?: string) => async (dispatch, getState) => {
  const { recaptchaActivated, recaptchaSiteKey } = await getState().config;

  dispatch({
    type: ACTION_TYPES.INIT_CREATE_PENDING_SUBSCRIPTION
  });

  let result;
  if (recaptchaActivated && recaptchaSiteKey !== '') {
    result = await subscriptionApi.createPendingSubscriptionWithRecaptcha(prospection, reCaptchaValue);
  } else {
    result = await subscriptionApi.createPendingSubscription(prospection);
  }

  if (result.isFailure) {
    dispatch({
      type: ACTION_TYPES.RESET_CREATE_PENDING_SUBSCRIPTION
    });
    globalError.next({ type: TYPE_ERROR.GLOBAL, error: result.errorValue() });
    return false;
  }

  const subscription = result.getValue();

  dispatch({
    type: ACTION_TYPES.SET_SUBSCRIPTION,
    payload: {
      subscriptionNumber: subscription.number,
      ...subscription
    }
  });

  return true;
};

export const getSubscriptionDocumentsSigned = () => async (dispatch, getState) => {
  const subscription = await getState().subscription;

  if (subscription?.status === 'VALIDATED') {
    const result = await subscriptionApi.getSubscriptionDocumentsSigned(subscription?.subscriptionNumber);
    if (result.isSuccess) {
      await dispatch({
        type: ACTION_TYPES.SET_DOCUMENTS_SIGNED,
        payload: result?.getValue()
      });
      return;
    }
  }

  await dispatch({
    type: ACTION_TYPES.SET_DOCUMENTS_SIGNED,
    payload: []
  });
};

export const validateSubscriptionAction = () => async (dispatch, getState) => {
  const subscription = await getState().subscription;

  if (subscription?.status === 'VALIDATED') {
    await dispatch(gtmEvent('Signature', 'Déjà signé', '0'));
    await dispatch(getSubscriptionDocumentsSigned());
  } else {
    await dispatch(gtmEvent('Signature', 'Erreur signature', 'documentsnotsigned'));
    history.push('/' + subscription?.subscriptionNumber + '/failure?error=documentsnotsigned');
  }
};

export const validateSubscription = () => async (dispatch, getState) => {
  const { subscriptionNumber } = await getState().subscription;
  await subscriptionApi.validateSubscription(subscriptionNumber);
};

export const requestSigningTransactionUrl = () => async (dispatch, getState) => {
  const { subscriptionNumber } = await getState().subscription;

  await dispatch({
    type: ACTION_TYPES.RESET_SIGN_ERROR
  });

  // Genrere une url
  const result = await subscriptionApi.requestSigningTransactionUrl(subscriptionNumber);

  if (result.isSuccess) {
    await dispatch({
      type: ACTION_TYPES.SET_SOURCE,
      payload: result.getValue()
    });
    return;
  } else {
    let i = 1;
    let success = false;
    while (i < 11 && !success) {
      // retry 10 fois
      console.log('Get Url Universign By Subscription : ' + i);
      await new Promise(resolve => setTimeout(resolve, 4000));

      // Check if url n'exite pas
      await dispatch(getSubscription(subscriptionNumber));
      const subscription = await getState().subscription;
      if (subscription && subscription.signTxnUrl && subscription.signTxnUrl.length > 0) {
        await dispatch({
          type: ACTION_TYPES.SET_SOURCE,
          payload: subscription.signTxnUrl
        });
        success = true;
        continue;
      }

      i++;
    }

    if (!success) {
      const errorMessage = translate('form.errors.messages.validateSubscription');
      await dispatch({
        type: ACTION_TYPES.SET_SIGN_ERROR,
        payload: errorMessage
      });
    }
  }
};
